import { Box, Grid, Typography } from '@mui/material';
import { Dialog } from '../../../../components/general/dialog/dialog';
import FieldText from '../../../../components/general/fields/fieldText';
import DropZoneField from '../../../../components/general/fields/dropzoneField';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import Loading from '../../../../components/general/loadings/loading';
import { PqrAttachmentProps } from './props';
import { Table } from '../../../../components/general/table';

export const AttachmentModal = ({
    formik,
    handleOnChange,
    openAttachmentsModal,
    handleCloseAttachmentsModal,
    handleSubmit,
    loading,
    columns,
    attachments,
}: PqrAttachmentProps) => {
    return (
        <Dialog
            title="Anexos"
            open={openAttachmentsModal}
            onClose={handleCloseAttachmentsModal}
            textSecondBtn="Guardar"
            onClickSecondBtn={handleSubmit}
        >
            <Box position="relative">
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <Typography fontWeight="bold" color="black">
                            Archivo adjunto
                        </Typography>
                    </Grid>

                    <Grid item xs={12}>
                        <DropZoneField
                            name="attachments"
                            title="Suelte los archivos aquí o haga click para subir (El tamaño máximo no debe superar 30MB)"
                            subtitle={null}
                            subtitle2={null}
                            maxFileSize={30 * 1024 * 1024}
                            onChange={handleOnChange as (files: any[]) => void}
                            touched={formik?.touched?.attachments}
                            errors={formik?.errors?.attachments}
                        >
                            <CloudUploadIcon fontSize="large" color="warning" />
                        </DropZoneField>
                    </Grid>
                    {attachments && attachments?.length > 0 && (
                        <Grid item xs={12}>
                            <Table
                                columns={columns || []}
                                rows={attachments}
                                rowCount={attachments.length}
                                pageSizeOptions={[10, 20, 50]}
                                disableRowSelectionOnClick
                            />
                        </Grid>
                    )}

                    <Grid item xs={12}>
                        <FieldText
                            label="Observación"
                            name="observation"
                            size="small"
                            required
                            rows={3}
                            onBlur={formik?.handleBlur}
                            touched={formik?.touched?.observation}
                            errors={formik?.errors?.observation}
                            value={formik?.values?.observation}
                            onChange={formik?.handleChange}
                        />
                    </Grid>
                </Grid>

                {loading && (
                    <Box
                        display="flex"
                        alignItems="center"
                        justifyContent="center"
                    >
                        <Loading />
                    </Box>
                )}
            </Box>
        </Dialog>
    );
};
